export default __webpack_public_path__ + "static/media/mail_verify_alt.9065e526.webp";